import React from "react";

interface CommentContentProps {
  content: string;
}
export const CommentContent: React.FC<CommentContentProps> = (props) => {
  const { content } = props;
  return <span className="text-base whitespace-pre-wrap">{content}</span>;
};
